import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { drizzleConnect } from 'drizzle-react';
import PersonalAddress from './PersonalAddress';
import NoAddress from './NoAddress';

class Address extends Component {
  constructor(props, context) {
    super(props);
    this.contract = context.drizzle.contracts.Alias;
    this.methods = this.contract.methods;
    this.web3Util = context.drizzle.web3.utils;
    this.state = {};
  }

  componentWillMount() {
      const { alias } = this.props.params;
      this.getAddressForAlias(alias).then(address => {
        this.setState({ address });
      });
  }

  getAddressForAlias(alias = '') {
    const bytes = this.web3Util.fromAscii(alias);
    return this.methods.get(bytes).call();
  }

  render() {
    const { address } = this.state;
    const { alias } = this.props.params;
    if (address === undefined) return null;
    return (
      <div>
        {Number(address) !== 0 ?
          <PersonalAddress address={address} alias={alias} /> :
          <NoAddress alias={alias} />
        }
      </div>
    );
  }
}

Address.contextTypes = {
  drizzle: PropTypes.object,
  contracts: PropTypes.object,
};

const mapStateToProps = state => {
  return {
    accounts: state.accounts,
    contracts: state.contracts,
    drizzleStatus: state.drizzleStatus,
    transactions: state.transactionStack
  }
};

export default drizzleConnect(Address, mapStateToProps);


// WEBPACK FOOTER //
// ./src/components/Address.js